import useAppTranslation from "@hooks/language/useAppTranslation";
import ButtonVariants from "./button/ButtonVariants";
import Icon from "./icon/Icon";
import InfoCard, { type ICardClassNames } from "./info-card/InfoCard";

interface IJoinDiscordInfoCardProps {
  text: string;
  classNames?: ICardClassNames;
}

const JoinDiscordInfoCard: React.FC<IJoinDiscordInfoCardProps> = ({
  text,
  classNames,
}) => {
  const { t } = useAppTranslation("components.joinDiscordInfoCard");
  return (
    <InfoCard
      button={<ButtonVariants.JoinDiscord className="mt-3 w-2/3" />}
      icon={<Icon.Discord size={50} />}
      text={text}
      title={t("title")}
      classNames={classNames}
    />
  );
};

export default JoinDiscordInfoCard;
